export default __webpack_public_path__ + "static/media/goodIcon.bc3a78c9.svg";